import type { Topic } from "@/types/content";

export default function TopicArticle({ topic }: { topic: Topic }) {
  return (
    <div className="space-y-8">
      <article>
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          事件梳理
        </h2>
        <div className="mt-4 space-y-4">
          {topic.content.map((paragraph, index) => (
            <p key={index} className="text-sm leading-loose text-foreground-700 md:text-base">
              {paragraph}
            </p>
          ))}
        </div>
      </article>

      <section aria-label="观点交锋现场" className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
        <div className="flex flex-wrap items-center gap-2">
          <span className="flex h-4 w-4 items-center justify-center text-primary-600">
            <i className="ri-sword-line" aria-hidden="true" />
          </span>
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
            观点交锋现场
          </h2>
          <span className="ml-auto font-label text-xs text-foreground-500">
            双方观点并列展示 · 不代站队
          </span>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-5">
            <div className="flex items-center gap-2">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                <i className="ri-thumb-up-line text-xs" aria-hidden="true" />
              </span>
              <h3 className="font-heading text-base font-bold text-secondary-900">
                支持一方的理由
              </h3>
            </div>
            <ul className="mt-4 space-y-3">
              {topic.pros.map((item, index) => (
                <li key={index} className="flex gap-2.5 text-sm leading-relaxed text-foreground-700">
                  <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center text-secondary-600">
                    <i className="ri-checkbox-circle-line" aria-hidden="true" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-primary-200 bg-primary-50 p-5">
            <div className="flex items-center gap-2">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-thumb-down-line text-xs" aria-hidden="true" />
              </span>
              <h3 className="font-heading text-base font-bold text-primary-900">
                反对方的顾虑
              </h3>
            </div>
            <ul className="mt-4 space-y-3">
              {topic.cons.map((item, index) => (
                <li key={index} className="flex gap-2.5 text-sm leading-relaxed text-foreground-700">
                  <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center text-primary-600">
                    <i className="ri-close-circle-line" aria-hidden="true" />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}